export default "__VITE_ASSET__BoTnKLbn__"